import { KeyLabelType, Nullable, NumberKeyLabelType } from '~/types'
import api from '../../api/http-common'
import { AxiosResponse } from 'axios'
import { CattleResultsType, ClimaCheckFeedType, ClimateCheckSelectType, CowResultsType, HeiferRaisingMethod, JuicyFeed, YoungCattleValidationFeedGroup } from './climaCheck'

const getCO2FootprintsOptions = (data?) =>
  api.post('/co2/footprints/get-index-data', data)

const getCO2Footprints = (data?) =>
  api.post('/co2/footprints/index', data)

const getCO2Count = (data?) =>
  api.post('/co2/footprints/count', data)

const getCO2CountActive = () =>
  api.post('/co2/footprints/count-active')

const getCO2OptionsData = () =>
  api.post('/co2/footprints/get-options-data')

const createCO2Footprint = (data?) =>
  api.post('/co2/footprints/store', data)

const getCO2Footprint = (id: string) =>
  api.post(`/co2/footprints/${id}/edit`)

const planCO2 = (id: string) =>
  api.post(`/co2/footprints/${id}/plan`)

const deleteCO2FootPrint = (id: string) =>
  api.post(`/co2/footprints/${id}/delete`)

const updateCO2Footprint = (id: string, data) =>
  api.post(`/co2/footprints/${id}/update`, data)

const getCO2AnswerOptions = (id: string, data?): ApiClientReturnType<CO2OptionsType> =>
  api.post(`/co2/footprints/${id}/answer/get-options-data`, data)

const storeCO2Answers = (id: string, data) =>
  api.post(`/co2/footprints/${id}/answer/store`, data)

const getCO2Results = (id: string, data) =>
  api.post(`/co2/footprints/${id}/answer/get-results`, data)

const getPredefinedData = (id: string, data: any) =>
  api.post(`/co2/footprints/${id}/answer/get-predefined-data`, data)

const getCO2SubmitData = (id: string, data?) =>
  api.post(`/co2/footprints/${id}/get-results`, data)

const getCO2ShowData = (id: string) =>
  api.post(`/co2/footprints/${id}/show`)

const getCO2AnswerData = (id: string, data?) =>
  api.post(`/co2/footprints/${id}/answer/edit`, data)

const getCO2FarmerGroups = (id: string, data) =>
  api.post(`/co2/footprints/${id}/farmer-groups/index`, data)

const getCO2Farmers = (id: string, data) =>
  api.post(`/co2/footprints/${id}/farmers/index`, data)

const getCO2List = () =>
  api.post('co2-footprints/list')

const getCo2File = (id: string, data: any) =>
  api.post(`/co2/footprints/${id}/get-file`, data)

const deleteCo2File = (id: string, data: any) =>
  api.post(`/co2/footprints/${id}/delete-file`, data)

const getCO2FarmerResults = (id: string, idFarmer: string) =>
  api.post(`/co2/footprints/${id}/farmers/${idFarmer}/get-results`)

const getEnergyData = (id: string, data): ApiClientReturnType<Co2EnergyDataType> =>
  api.post(`/co2/footprints/${id}/answer/get-energy-data`, data)

const calculateEnergyData = (id: string, type: ClimaCheckFeedType, data?) =>
  api.post(`/co2/footprints/${id}/answer/${type}/calculate-energy-addition`, data)

const getCo2PreviewFile = (id: string) =>
  api.post(`/co2/footprints/${id}/get-file`)

const noShowCheckedSave = (id: string, data?) =>
  api.post(`/co2/footprints/${id}/answer/disable-file-preview`, data)

const co2Farmers = (id: string, data) =>
  api.post(`/co2/footprints/${id}/farmers/index`, data)

const saveCo2Draft = (id: string, data) =>
  api.post(`/co2/footprints/${id}/answer/save`, data)

const checkCo2Status = (id: string, data?) =>
  api.post(`/co2/footprints/${id}/answer/check`, data)

const getCo2Settings = () =>
  api.post('settings/co2-footprint/edit')

const updateCo2Settings = (data: any) =>
  api.post('settings/co2-footprint/update', data)

const getClimaChDlgFeed = (id: string, data) =>
  api.post(`/co2/footprints/${id}/answer/heifers/get-feeds`, data)

const getCowsResults = (id: string, data?): ApiClientReturnType<CowResultsType> =>
  api.post(`/co2/footprints/${id}/answer/cows/get-results`, data)

const getHeifersResults = (id: string, data?): ApiClientReturnType<CattleResultsType> =>
  api.post(`/co2/footprints/${id}/answer/heifers/get-results`, data)

const getGrassSilagePredefinedData = (id: string, data: any): ApiClientReturnType<GrassPredDataType> =>
  api.post(`/co2/footprints/${id}/answer/grass-silage/get-predefined-data`, data)

const getCowPredData = (id: string, data: any) =>
  api.post(`/co2/footprints/${id}/answer/cows/get-predefined-data`, data)

const getHeifersPredData = (id: string, data: any) =>
  api.post(`/co2/footprints/${id}/answer/heifers/get-predefined-data`, data)

const getClimaChEnergyData = (id: string, type: ClimaCheckFeedType, data?) =>
  api.post(`/co2/footprints/${id}/answer/${type}/get-energy-data`, data)

const getResults = (id: string, data?): ApiClientReturnType<Co2ResultsType> =>
  api.post(`/co2/footprints/${id}/answer/get-results`, data)

const getMaizeSilagePredefinedData = (id: string, data: any): ApiClientReturnType<GrassPredDataType> =>
  api.post(`/co2/footprints/${id}/answer/maize-silage/get-predefined-data`, data)

const getCO2PreviousData = (id: string) =>
  api.post(`/co2/footprints/${id}/answer/get-previous-data`)

const CO2Service = {
  getCO2FootprintsOptions,
  getCO2Footprints,
  getCO2Count,
  getCO2CountActive,
  getCO2OptionsData,
  getCO2Footprint,
  createCO2Footprint,
  updateCO2Footprint,
  planCO2,
  deleteCO2FootPrint,
  getCO2AnswerOptions,
  storeCO2Answers,
  getCO2Results,
  getPredefinedData,
  getCO2SubmitData,
  getCO2ShowData,
  getCO2FarmerGroups,
  getCO2Farmers,
  getCO2FarmerResults,
  getCO2AnswerData,
  getCO2List,
  getCo2File,
  deleteCo2File,
  getEnergyData,
  calculateEnergyData,
  getCo2PreviewFile,
  noShowCheckedSave,
  co2Farmers,
  saveCo2Draft,
  checkCo2Status,
  getCo2Settings,
  updateCo2Settings,
  getClimaChDlgFeed,
  getCowsResults,
  getHeifersResults,
  getGrassSilagePredefinedData,
  getCowPredData,
  getHeifersPredData,
  getClimaChEnergyData,
  getResults,
  getMaizeSilagePredefinedData,
  getCO2PreviousData
}

export default CO2Service

export interface CO2OptionsType {
  breeds: BreedType[];
  youngCattleBreeds: ClimateCheckSelectType[];
  heiferRaisingMethods: HeiferRaisingMethod[];
  calfRearingTypes: NumberKeyLabelType[];
  housingTypes: HousingType[];
  manureStorageTypes: ClimateCheckSelectType[];
  energyConsumptions: EnergyConsumption[];
  cowsConcentratedFeeds: ConcentratedFeeds;
  youngCattleConcentratedFeeds: ConcentratedFeeds;
  juicyFeeds: JuicyFeed[];
  cowsCoarseFeeds: CowsCoarseFeed[];
  youngCattleCoarseFeeds: CowsCoarseFeed[];
  silageConcentratedFeeds: CowsCoarseFeed[];
  silageCoarseFeeds: CowsCoarseFeed[];
  emissionReducingAdditives: EmissionReducingAdditive[];
  landTypes: ClimateCheckSelectType[];
  manureFermentations: ClimateCheckSelectType[];
  dairy: Dairy;
  co2Footprint: Co2Footprint;
  farmer: Farmer;
  filePreview: boolean;
  months: KeyLabelType[];
  useMilkPrice: number;
  silageTypes: SilageType[];
  pruningPhases: PruningPhases[];
  locationFavorabilityTypes: KeyLabelType[];
  fertilizationTypes: KeyLabelType[];
  cuttingFrequencies: KeyLabelType[];
  fieldSizes: KeyLabelType[];
  maturityLevels: MaturityType[];
  grainContentTypes: KeyLabelType[];
  mineralFertilizers: Fertilizer[];
  organicFertilizers: Fertilizer[];
  mineralFertilizerApplicationTechniques: PruningPhases[];
  pestProtectionIntensities: KeyLabelType[];
  useAdditivesTabOnCollectingData: number;
  youngCattleValidationFeedGroups: YoungCattleValidationFeedGroup[];
}

type MaturityType = PruningPhases & {
  hasGrainContentOptions: number
}

type BreedType = Omit<PruningPhases, 'apiId'>

export interface PruningPhases {
  id: number;
  slug: string;
  label: string;
  order?: number;
  apiId: number;
}

export interface Co2Footprint {
  id: string;
  periodFrom: Date;
  periodTo: Date;
  start: string;
  end: string;
  statusLabel: string;
}

export interface CowsCoarseFeed {
  id: number;
  internal_id?: number;
  slug: string;
  name: string;
  status: number;
  type: number;
  order: number;
  is_silage_feed?: number;
  label: string;
  group?: number | null;
  groupLabel?: GroupLabel;
  info?: string;
  internalId?: number;
  isSilageFeed?: number;
}

export enum GroupLabel {
  Eiweißkraftfutter = 'Eiweißkraftfutter',
  Empty = '',
  Energiekraftfutter = 'Energiekraftfutter',
  SonstigeUndMineralfutter = 'Sonstige und Mineralfutter',
}

export interface ConcentratedFeeds {
  Energiekraftfutter: CowsCoarseFeed[];
  Eiweißkraftfutter: CowsCoarseFeed[];
  'Sonstige und Mineralfutter': CowsCoarseFeed[];
  ''?: CowsCoarseFeed[];
}

export interface Dairy {
  companyName: string;
  languageId: number;
}

export interface EmissionReducingAdditive {
  id: number;
  slug: string;
  status: number;
  hasTextAnswer: number;
  order: number;
  label: string;
}

export interface EnergyConsumption {
  id: number;
  slug: string;
  category: number;
  order: number;
  parentId: number | null;
  apiKey: null | string;
  label: string;
  dataSource: string;
  info: string;
  children?: EnergyConsumption[];
}

export interface Farmer {
  id: string;
  companyName: string;
  supplierNo: string;
  totalMilkAmount: number;
  fat: null;
  protein: null;
  milkPrice: null;
  ureaContent: null;
  addressableId: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  city: string;
  countryId: number;
  localDistrict: null;
  stateId: number;
  districtId: number;
  agricultureDistrictId: null;
  latitude: string;
  longitude: string;
  administrativeDistrictId: number;
  iso: string;
  label: string;
  stateName: string;
  abbreviation: string;
  standardFat: string;
  standardProtein: string;
  fatPrice: string;
  proteinPrice: string;
  districtName: string;
  agricultureDistrict: null;
  amounts: any[];
  farmerId: string;
  dateFrom: Date;
  dateTo: null;
  saleTaxId: string;
  name: string;
  percent: string;
  status: number;
  saleTaxLabel: string;
}

export interface HousingType {
  id: number;
  slug: string;
  order: number;
  label: string;
  cowsTooltip: string;
  calvesTooltip: string;
}

export interface Fertilizer {
  id: number;
  slug: string;
  type: string;
  apiId: number;
  unit: Unit;
  n: string;
  p2o5: string;
  k2o: string;
  nUsable: string;
  p2o5Usable: string;
  k2oUsable: string;
  order: number;
  label: string;
  typeLabel: string;
}

export enum Unit {
  Dt = 'dt',
  M3 = 'm3',
  T = 't',
}

export interface SilageType {
  id: number;
  slug: string;
  order: number;
  status: number;
  label: string;
  harvestingMethods: HarvestingMethod[];
  workOperations: WorkOperation[];
  organicFertilizerApplicationTechniques: HarvestingMethod[];
}

export interface HarvestingMethod {
  id: number;
  slug: string;
  silageTypeId: number;
  apiId: number;
  order: number;
  hasMaturityLevelOptions?: number;
  label: string;
  co2OrganicFertilizerApplicationTechniqueId?: number;
  workOperationId?: number;
  harvestingMethodId?: null;
  percent?: number;
}

export type Co2EnergyDataType = {
  maintenanceNeedsEnergy: number
  powerRequirementEnergy: number
  reproductionNeedsEnergy: number
  totalEnergy: number
}
export interface WorkOperation {
  id: number;
  slug: string;
  disabled: number;
  apiId: number;
  order: number;
  label: string;
  silageTypeId: number;
  limitValue: Nullable<number>;
  workOperationId: number;
  harvestingMethodId: null;
  passages?: string;
  defaultValue?: string;
  distance?: string;
  info?: string;
  seedsRequired?: number;
}

export interface GrassSilage {
  grassSilageSeed: number;
  grassSilageFertilization: number;
  grassSilageCropResidues: number;
  grassSilageCropProtection: number;
  grassSilageSiloMaintenance: number;
  grassSilageDieselProductionAndCombustion: number;
  grassSilageGhgEmissionPerHa: number;
  grassSilageGhgEmissionProduction: number;
  grassSilageGhgEmissionField: number;
  grassSilageGhgEmissionFreshMass: number;
  grassSilageGhgEmissionDryMatter: number;
}

export interface MaizeSilage {
  maizeSilageSeed: number;
  maizeSilageFertilization: number;
  maizeSilageCropResidues: number;
  maizeSilageCropProtection: number;
  maizeSilageSiloMaintenance: number;
  maizeSilageDieselProductionAndCombustion: number;
  maizeSilageGhgEmissionPerHa: number;
  maizeSilageGhgEmissionProduction: number;
  maizeSilageGhgEmissionField: number;
  maizeSilageGhgEmissionFreshMass: number;
  maizeSilageGhgEmissionDryMatter: number;
}

export interface YoungCattle {
  youngCattleGhgEmissionHeifersIdf: number;
  youngCattleFemaleCalf: number;
  youngCattleDigestion: number;
  youngCattleFeedProductionAndLosses: number;
  youngCattleManureAndBedding: number;
  youngCattleWaterAndEnergy: number;
  youngCattleDieselProductionAndCombustion: number;
  youngCattleTotal: number;
  youngCattleMachineManufacturing: number;
  youngCattleGhgEmissionIdfPerHeifer: number;
}

export interface Cows {
  ghgEmissionMilkIdf: number;
  ghgEmissionSlaughterCowsIdf: number;
  ghgEmissionCalvesIdf: number;
  soldMilk: number;
  soldMilkFpcm: number;
  soldMilkEconomicAllocationFpcm: number;
  soldMilkEconomicAllocationFpcmIdf: number;
  total: number;
  inventoryAddition: number;
  calfRearing: number;
  digestion: number;
  feedProductionAndLosses: number;
  feeding: number;
  manureAndBedding: number;
  waterAndEnergy: number;
  dieselProductionAndCombustion: number;
  machineManufacturing: number;
}

export interface Co2ResultsType {
  grassSilage: GrassSilage;
  maizeSilage: MaizeSilage;
  youngCattle: YoungCattle;
  cows: Cows;
}

export interface GrassPredDataType {
  workOperations: WorkOperation[]
  freshMassYield: number
  energy: number
  rawProtein: number
  dryMatter: number
}

type ApiClientReturnType<T> = Promise<AxiosResponse<T>>;